import React from 'react';
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon';

export default createSvgIcon(
  <path d="M20 14C20 11.0545 17.3333 7.05448 12 2C6.66667 7.05448 4 11.0545 4 14C4 18.4183 7.58172 22 12 22C16.4183 22 20 18.4183 20 14ZM12 4.793L12.5401 5.34306C15.6205 8.52377 17.3782 11.1173 17.8619 13.0013H6.13806C6.63844 11.0523 8.50224 8.34407 11.7832 5.01194L12 4.793Z" />,
  'Opacity'
);
